import QRCode from 'qrcode';

export const generateQRBase64 = async (text: string): Promise<string> => {
  try {
    const dataUrl = await QRCode.toDataURL(text, {
      width: 200,
      margin: 2,
      errorCorrectionLevel: 'H',
    });
    return dataUrl.replace(/^data:image\/png;base64,/, "");
  } catch (err) {
    console.error('Ошибка генерации QR:', err);
    throw err;
  }
};